// A single frontend build serves both the .de and .ch domains. Prices shown to
// the user are denominated per country: euro on .de, Swiss franc on .ch. The
// domain is the source of truth (same rule as service/stripeConfig.ts).

export const isSwissDomain = (): boolean =>
  typeof window !== 'undefined' && window.location.hostname.endsWith('.ch')

export const getCurrencySymbol = (): string => (isSwissDomain() ? 'CHF' : '€')

// Puts the symbol where it reads naturally for each currency: "€12.00", "CHF 12.00".
export const formatPrice = (value: number | string): string =>
  isSwissDomain() ? `CHF ${value}` : `€${value}`
